import React, { useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import ScheduleSummaryDetail from './ScheduleSummaryDetail'
import ScheduleSummaryDetailJobInstruction from './ScheduleSummaryDetailJobInstruction'
import { formatDate } from '../../utils';

import i18next from 'i18next';

const useStyles = makeStyles((theme) => ({
    divTime: {
        border: '1px dashed #787878',
        padding: '10px',
        marginBottom: '15px',
        fontSize: '10px'
    },
    divBox_1: {
        border: '1px solid #787878',
        padding: '6px',
        fontSize: '10px'
    },
    top: {
        marginTop: '10px'
    },
    noBorder: {
        border: '0px'
    }
}));

export default function ScheduleWeekPrintDetail(props) {
    const classes = useStyles();
    const { data } = props;

    useEffect(() => {
    }, []);

    return (
        <div id="divRootPrint">
            <TableContainer>
                <Table className={classes.table} aria-label="spanning table">
                    <TableBody>
                        {data != null && data.map((obj, index) =>
                            <React.Fragment key={index}>
                                <TableRow>
                                    <TableCell className={classes.noBorder}>
                                        <div>
                                            <div className={classes.divTime}>
                                                <div>
                                                    <span className={classes.divTimeLabel}>{i18next.t('schedule:list.start')} : </span>
                                                    <span className={classes.divTimeDescription}>{formatDate(obj.startDate)}</span>
                                                </div>
                                                <div>
                                                    <span className={classes.divTimeLabel}>{i18next.t('schedule:list.end')} : </span>
                                                    <span className={classes.divTimeDescription}>{formatDate(obj.endDate)}</span>
                                                </div>
                                            </div>
                                            <div className={classes.divBox_1}>
                                                <div className={classes.divBox_1}><b>{i18next.t("schedule:tabPanel.infoClient")}</b></div>
                                                <ScheduleSummaryDetail data={obj} />
                                            </div>
                                            {obj.workInstructions && <div className={classes.divBox_1 + " " + classes.top}>
                                                <div className={classes.divBox_1}><b>{i18next.t("schedule:tabPanel.instruction")}</b></div>
                                                <ScheduleSummaryDetailJobInstruction data={obj} />
                                            </div>}
                                        </div>
                                    </TableCell>
                                </TableRow>
                            </React.Fragment>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}